import { render, staticRenderFns } from "./WingsPage.vue?vue&type=template&id=6e75543e&scoped=true&"
import script from "./WingsPage.vue?vue&type=script&lang=js&"
export * from "./WingsPage.vue?vue&type=script&lang=js&"
import style0 from "./WingsPage.vue?vue&type=style&index=0&id=6e75543e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75543e",
  null
  
)

export default component.exports